import { useTranslation } from 'react-i18next';

import Button from '../../../elements/button';
import Logger from '../../../helpers/logger';
import { useHistory } from '../../../helpers/routing';

interface BackButtonProps {
  className?: string;
}

export const BackButton = ({ className }: BackButtonProps) => {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <Button
      className={`back-button ${className}`}
      onClick={() => {
        Logger.logEvent('Clicked Back Button', null);
        history.goBack();
      }}
      isBackButton={true}
    >
      {t('back')}
    </Button>
  );
};

export default {
  BackButton,
};
